//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QrcodeVue from 'qrcode.vue';
import { copyToClipboard } from '@/utils/tools.js';
import { isMobile } from '@/utils/constants';

export default {
  name: 'share',
  components: {
    QrcodeVue,
  },
  props: ['title', 'resourceInfo'],
  data() {
    return {
      showList: false,
      qrcode: false,
      shareList: [
        { name: 'weibo', icon: 'weibo', event: this.toShare, orginChannel: 'sina_weibo' },
        { name: 'qzone', icon: 'qzone', event: this.toShare, orginChannel: 'qq_qzone' },
        { name: 'wechat', icon: 'wechat', event: null, orginChannel: 'wechat_qr' },
        { name: 'copy', icon: 'share', event: this.onCopy, orginChannel: 'copy' },
      ],
      url: location.origin + location.pathname,
      params: {
        action_position: 'community',
        action_parameter0: 'community_resource',
        action_detail: 'share',
        resource_id: this.resourceInfo.res_id,
        resource_name: this.resourceInfo.res_name,
      },
    };
  },
  computed: {
    shareTitle() {
      return encodeURIComponent(`【${this.title}】，前往“MasterGo设计”，查看并使用→`);
    },
    qzone() {
      const shareUrl = encodeURIComponent(`${this.url}?orginChannel=mgshare_qzone`);
      return `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${shareUrl}&title=${this.shareTitle}`;
    },
    weibo() {
      const shareUrl = encodeURIComponent(`${this.url}?orginChannel=mgshare_weibo`);
      return `http://service.weibo.com/share/share.php?url=${shareUrl}&title=${this.shareTitle}`;
    },
    wechat() {
      return `${this.url}?orginChannel=mgshare_wechat`;
    },
  },
  mounted() {
    if (this.$route.query.orginChannel) {
      this.$sensors.track('page_view', {
        orginChannel: this.$route.query.orginChannel,
        resource_id: this.resourceInfo.res_id,
        resource_name: this.resourceInfo.res_name,
      });
    }
  },
  methods: {
    showShareList(show, e = 'mouse') {
      if (isMobile() && e === 'mouse') return;
      this.showList = show;
      if (show) {
        this.$sensors.track('event_click', {
          ...this.params,
          action_type: 'hover',
        });
      } else {
        this.qrcode = false;
      }
    },
    toShare(item) {
      if (item.name === 'copy') {
        this.onCopy();
      } else {
        window.open(this[item.name], '__blank', 'noopener,noreferrer');
      }
      this.$sensors.track('event_click', {
        ...this.params,
        action_type: 'click',
        select_platform: item.orginChannel,
      });
    },
    onCopy() {
      copyToClipboard(this.url);
      this.$message({
        message: '分享链接已复制，快去分享吧...',
        type: 'success',
      });
    },
    showQrcode(show, e = 'mouse') {
      if (isMobile() && e === 'mouse') return;
      this.qrcode = show;
      if (show) {
        this.$sensors.track('event_click', {
          ...this.params,
          action_type: 'click',
          select_platform: 'wechat_qr',
        });
      }
    },
  },
};
